export default __webpack_public_path__ + "static/media/jocko.fb526e19.jpg";